// http://lea.verou.me/2009/12/reading-cookies-the-regular-expression-way/

export function get(name, c) {
	c = c || (typeof window !== 'undefined' && window.document.cookie) || ''
    name = name.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1')
    const regex = new RegExp('(?:^|;)\\s?' + name + '=(.*?)(?:;|$)','i')
	const match = c.match(regex)
    return match && unescape(match[1])
}
